module.exports = __webpack_public_path__ + "img/034.e4b20070.jpg";